<template>
    <div class="wa-empty-state">
        <div class="wa-empty-state__inner">
            <div class="wa-empty-state__icon-wrapper">
                <svg viewBox="0 0 303 172" class="wa-empty-state__laptop">
                    <defs>
                        <linearGradient id="a" x1="50%" y1="0%" x2="50%" y2="100%">
                            <stop offset="0%" stop-color="#25D366" stop-opacity=".15" />
                            <stop offset="100%" stop-color="#128C7E" stop-opacity=".05" />
                        </linearGradient>
                    </defs>
                    <rect x="1" y="1" width="301" height="140" rx="12" fill="url(#a)" stroke="#25D366" stroke-opacity=".3" stroke-width="1.5" />
                    <rect x="20" y="20" width="120" height="100" rx="6" fill="#25D366" fill-opacity=".12" />
                    <rect x="163" y="20" width="120" height="45" rx="6" fill="#128C7E" fill-opacity=".1" />
                    <rect x="163" y="74" width="120" height="46" rx="6" fill="#128C7E" fill-opacity=".1" />
                    <rect x="0" y="142" width="303" height="30" rx="6" fill="#25D366" fill-opacity=".08" />
                    <rect x="121" y="150" width="61" height="4" rx="2" fill="#25D366" fill-opacity=".3" />
                </svg>
                <div class="wa-empty-state__lock-icon">
                    <svg viewBox="0 0 24 24" width="28" height="28" fill="none">
                        <path d="M12 1C9.24 1 7 3.24 7 6v2H5a2 2 0 00-2 2v11a2 2 0 002 2h14a2 2 0 002-2V10a2 2 0 00-2-2h-2V6c0-2.76-2.24-5-5-5zm0 2c1.66 0 3 1.34 3 3v2H9V6c0-1.66 1.34-3 3-3zm0 10a2 2 0 110 4 2 2 0 010-4z" fill="#25D366" fill-opacity=".7"/>
                    </svg>
                </div>
            </div>
            <h2 class="wa-empty-state__title">{{ $t("whatsappUi.emptyTitle") }}</h2>
            <p class="wa-empty-state__subtitle">{{ $t("whatsappUi.emptySubtitle") }}</p>
            <div class="wa-empty-state__features">
                <div class="wa-empty-state__feature">
                    <span class="wa-empty-state__feature-icon">💬</span>
                    <span>{{ $t("whatsappUi.featureChannels") }}</span>
                </div>
                <div class="wa-empty-state__feature">
                    <span class="wa-empty-state__feature-icon">📋</span>
                    <span>{{ $t("whatsappUi.featureTemplates") }}</span>
                </div>
                <div class="wa-empty-state__feature">
                    <span class="wa-empty-state__feature-icon">🔔</span>
                    <span>{{ $t("whatsappUi.featureRealtime") }}</span>
                </div>
            </div>
            <div class="wa-empty-state__encryption">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none">
                    <path d="M12 1C9.24 1 7 3.24 7 6v2H5a2 2 0 00-2 2v11a2 2 0 002 2h14a2 2 0 002-2V10a2 2 0 00-2-2h-2V6c0-2.76-2.24-5-5-5z" fill="#667781"/>
                </svg>
                <span>{{ $t("whatsappUi.encryptionFooter") }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WAEmptyState",
};
</script>

<style lang="scss" scoped>
.wa-empty-state {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f2f5;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2325d366' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        opacity: 0.5;
    }

    &__inner {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        max-width: 380px;
        padding: 40px 24px;
    }

    &__icon-wrapper {
        position: relative;
        margin-bottom: 24px;
    }

    &__laptop {
        width: 200px;
        height: auto;
    }

    &__lock-icon {
        position: absolute;
        bottom: -8px;
        right: -8px;
        background: #fff;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 2px 8px rgba(0,0,0,0.12);
    }

    &__title {
        font-size: 22px;
        font-weight: 300;
        color: #111b21;
        margin: 0 0 12px;
        letter-spacing: -0.3px;
    }

    &__subtitle {
        font-size: 14px;
        color: #667781;
        margin: 0 0 28px;
        line-height: 1.6;
    }

    &__features {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 32px;
        width: 100%;
    }

    &__feature {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 13px;
        color: #667781;
        background: rgba(255,255,255,0.7);
        border-radius: 10px;
        padding: 10px 16px;
        text-align: left;
    }

    &__feature-icon {
        font-size: 18px;
        flex-shrink: 0;
    }

    &__encryption {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #667781;
        opacity: 0.8;
    }
}
</style>
